import React, { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

/* ACTIONS */
import { getSurvey, postSurvey } from '../../actions/surveyAction';

/* UTILS */
import { getCloudImageUrl } from '../../utils/Helpers';

/* ASSETS */
import Mobile from '../../images/mobile-icon.png';
import AppStore from '../../images/app-store.png';
import GooglePlay from '../../images/google-play.png';
import Back from '../../images/black-mii-left.png';
import Next from '../../images/black-mii-right.png';
import NextNew from '../../images/filter-mii-right.png';
import SurveyCheck from '../../images/survey-check.png';

const MobileIcon: any = Mobile;
const AppStoreIcon: any = AppStore;
const GooglePlayIcon: any = GooglePlay;
const BackIcon: any = Back;
const NextIcon: any = Next;
const NextNewIcon: any = NextNew;
const SurveyCheckIcon: any = SurveyCheck;

/* LOCAL TYPE AND INTERFACE */
type SurveyModalProps = {
  userdata: any;
  surveyList: any;
  userSurvey: any;
  show: boolean;
  welcomePage?: boolean;
  handleShowSurvey: () => void;
  getSurveyList: (query: any) => any;
  postSurvey: (query: any) => any;
};

interface option {
  active?: boolean;
  created_at?: string;
  id?: number | null;
  img_url?: string | null;
  label?: string | null;
  next_id?: number | null;
  option_id?: number | null;
  optionable_id?: number | null;
  order?: number | null;
  parent_id?: number | null;
  survey_id?: number | null;
  updated_at?: string;
}

interface list {
  active?: boolean;
  created_at?: string;
  id?: number;
  img_url?: string | null;
  message?: string;
  multiple_option?: boolean;
  option?: Array<option>;
  length?: number;
  order?: number;
  parent_id?: null;
  question?: string;
  status_code?: number | null;
  updated_at?: string;
}

/* RENDER COMPONENTS */
const ContentCard = ({
  name,
  imageUrl,
  handleSelectOption,
  selectCard,
  isBrands,
  isSize,
}) => {
  return (
    <div
      className={`category-card ${selectCard}`}
      onClick={() => handleSelectOption()}
    >
      {selectCard && <KickImage className="survey-check" src={SurveyCheckIcon} />}
      {isSize || !imageUrl ? (
        <p className="size">{name} </p>
      ) : (
        <KickImage className="list-image" src={imageUrl} />
      )}
      {/* {!isBrands && isSize && <p>{name} </p>} */}
    </div>
  );
};

const InitialProcess = ({ handleContinue }) => {
  return (
    <Modal.Body className="survey-modal-body-opener">
      <div className="mobile-icon-wrapper">
        <KickImage src={MobileIcon} alt="mobile-icon" />
      </div>
      <div className="text-wrapper">
        <div className="description-wrapper">
          <div className="text-info">
            <h3>
              Hi, welcome to <span>Kick Avenue!</span>
            </h3>
            <p>
              Thousands of authentic sneakers, apparel, luxury, and eletronics &
              collectibles items in the palm of your hand. What are you waiting
              for? Immerse yourself in the latest trend in fashion.
            </p>
          </div>
          <div className="download-wrapper">
            <h5>Download Our App</h5>
            <div className="download-button-wrapper">
              <div className="app-store-wrapper">
                <KickImage src={AppStoreIcon} alt="app-store" />
              </div>
              <div className="google-play-wrapper">
                <KickImage src={GooglePlayIcon} alt="google-play" />
              </div>
            </div>
          </div>
        </div>
        <div className="button-wrapper">
          <div className="next-btn" onClick={() => handleContinue()}>
            <p>Next</p>
            <KickImage src={NextNewIcon} alt="back-icn" />
          </div>
        </div>
      </div>
    </Modal.Body>
  );
};

const SurveyContaier = ({
  title,
  children,
  handleBack,
  handleContinue,
  selectedClass,
  handleCompleteSurvey,
  next_id,
  currentProcess,
}) => {
  console.log(currentProcess);
  return (
    <Modal.Body className={`survey-choose-category ${selectedClass}`}>
      <div className="title-wrapper">
        <h3>{title}</h3>
      </div>
      {children}
      <div className="category-button-wrapper">
        {currentProcess && currentProcess > 1 ? (
          <div className="back-button" onClick={() => handleBack()}>
            <KickImage src={BackIcon} alt="back-icn" />
            <p>Back</p>
          </div>
        ) : (
          ''
        )}
        <div onClick={() => handleCompleteSurvey()} className="skip-button">
          <p>Skip for now</p>
        </div>
        <div
          className={`next-button ${selectedClass ? '' : 'disabled'}`}
          onClick={() => handleContinue()}
        >
          <p>{next_id ? 'Next' : 'Done'}</p>
          <KickImage src={selectedClass ? NextNew : NextIcon} alt="..." />
        </div>
      </div>
    </Modal.Body>
  );
};

const Cards = ({
  data,
  length,
  className,
  handleSelectOption,
  selectedCard,
  isBrands,
  isSize,
}) => {
  return (
    <div className={`${className}`}>
      {data.map((list, index) => {
        return index < length ? (
          <ContentCard
            imageUrl={getCloudImageUrl(list.img_url)}
            name={list.label}
            handleSelectOption={() => handleSelectOption(list)}
            selectCard={selectedCard[`${list.id}`] ? 'selected-card' : ''}
            isBrands={isBrands}
            isSize={isSize}
          />
        ) : null;
      })}
    </div>
  );
};

const SurveyModal: React.FC<SurveyModalProps> = ({
  show,
  userdata,
  surveyList,
  userSurvey,
  welcomePage,
  getSurveyList,
  handleShowSurvey,
  postSurvey,
}): JSX.Element => {
  const [process, setProcess] = useState([
    {
      currentProcess: 0,
      list: {},
      selectedOption: {},
    },
  ]);

  /* METHODS | FUNCTIONS | HANDLERS */
  const handleContinue = () => {
    const processLen = process.length;
    const { list, selectedOption } = process[processLen - 1];
    const arrayOfOptionId = Object.values(selectedOption).map(
      (option) => option.id,
    );

    /* POST SURVEY */
    const params = {
      user_id: userdata.id,
      survey_id: list?.id,
      survey_option_id: arrayOfOptionId,
    };
    postSurvey(params);
  };

  const handleBack = () => {
    const tempProcess = JSON.parse(JSON.stringify(process));
    tempProcess.pop();
    setProcess(JSON.parse(JSON.stringify(tempProcess)));
  };

  const handleSelectOption = (option) => {
    const tempProcess = JSON.parse(JSON.stringify(process));
    let { selectedOption, list } = tempProcess[tempProcess.length - 1];

    if (!list.multiple_option) {
      if (selectedOption[`${option.id}`]) {
        delete selectedOption[`${option.id}`];
      } else {
        for (let opt in selectedOption) delete selectedOption[opt];
        selectedOption[`${option.id}`] = option;
      }
      const newTempProcess = JSON.parse(JSON.stringify(tempProcess));
      return newTempProcess;
    } else {
      if (selectedOption[`${option.id}`]) {
        delete selectedOption[`${option.id}`];
      } else {
        selectedOption[`${option.id}`] = option;
      }
      return tempProcess;
    }
  };

  useEffect(() => {
    if (surveyList.question) {
      const params = {
        currentProcess: surveyList.order,
        list: surveyList,
        selectedOption: {},
      };
      const tempProcess = [...process, params];
      setProcess(JSON.parse(JSON.stringify(tempProcess)));
    }
  }, [surveyList]);

  useEffect(() => {
    if (userSurvey.status_code === 200 && !userSurvey.isSubmit) {
      const processLen = process.length;
      const { selectedOption } = process[processLen - 1];

      const filteredOption = Object.values(selectedOption);
      const params = {
        child: filteredOption?.[0]?.next_id,
        option: filteredOption?.[0]?.optionable_id,
      };
      if (filteredOption?.[0]?.next_id === null) {
        handleShowSurvey();
      } else {
        getSurveyList(params);
      }
    }
  }, [userSurvey]);

  useEffect(() => {
    setProcess([
      {
        currentProcess: 0,
        list: {},
        selectedOption: {},
      },
    ]);
    console.log(process);
  }, []);

  const renderData = (initialPage = true) => {
    const processLen = process.length;
    const { list, selectedOption, currentProcess } = process[processLen - 1];

    let currentOrder = currentProcess;

    if (!initialPage && currentOrder === 0) {
      getSurveyList(null);
      currentOrder = 3;
    }

    const isSelected = Object.keys(selectedOption).length > 0;
    const { option = [], question } = list;
    const next_id = option.length > 0 ? option[0].next_id : null;
    switch (currentOrder) {
      case 0:
        return <InitialProcess handleContinue={() => getSurveyList(null)} />;
      case 3:
        return (
          <SurveyContaier
            currentProcess={currentProcess}
            handleBack={handleBack}
            handleContinue={() => isSelected && handleContinue()}
            selectedClass={isSelected ? 'selected' : ''}
            title={question}
            handleCompleteSurvey={handleShowSurvey}
            next_id={next_id}
          >
            <Cards
              data={option}
              length={option.length}
              className={`brands-card-wrapper`}
              handleSelectOption={(option) =>
                setProcess(handleSelectOption(option))
              }
              selectedCard={selectedOption}
              isBrands={true}
            />
          </SurveyContaier>
        );
      case 4:
        return (
          <SurveyContaier
            currentProcess={currentProcess}
            handleBack={handleBack}
            handleContinue={() => isSelected && handleContinue()}
            selectedClass={isSelected ? 'selected' : ''}
            title={question}
            handleCompleteSurvey={handleShowSurvey}
            next_id={next_id}
          >
            <Cards
              data={option}
              length={option.length}
              className={`size-card-wrapper`}
              handleSelectOption={(option) =>
                setProcess(handleSelectOption(option))
              }
              selectedCard={selectedOption}
              isBrands={true}
              isSize={true}
            />
          </SurveyContaier>
        );
      default:
        return (
          <SurveyContaier
            currentProcess={currentProcess}
            handleBack={handleBack}
            handleContinue={() => isSelected && handleContinue()}
            selectedClass={isSelected ? 'selected' : ''}
            title={question}
            handleCompleteSurvey={handleShowSurvey}
            next_id={next_id}
          >
            <Cards
              data={option}
              length={option.length}
              className={`category-card-wrapper grid-${option.length}`}
              handleSelectOption={(option) =>
                setProcess(handleSelectOption(option))
              }
              selectedCard={selectedOption}
              isBrands={false}
            />
          </SurveyContaier>
        );
    }
  };

  return (
    <Modal scrollable={true} show={show} id="survey-modal-container">
      {renderData(welcomePage)}
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  surveyList: state.dataSurvey.survey,
  userSurvey: state.dataSurvey.userSurvey,
  userdata: state.dataAuth.userdata,
});

const mapDispatchToProps = (dispatch) => ({
  getSurveyList: (query: any) => dispatch(getSurvey(query)),
  postSurvey: (query: any) => dispatch(postSurvey(query)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SurveyModal));
